import CryptoJS from "crypto-js";

export const getCookie = (name: string): string | null => {
  let matches = document.cookie.match(
    new RegExp(
      "(?:^|; )" + name.replace(/([.$?*|{}()[]\\\/\+])/g, "\\$1") + "=([^;]*)"
    )
  );
  return matches ? decodeURIComponent(matches[1]) : null;
};

export const parseSearch = () => {
  const search = document.location.search.replace("?", "");
  if (search.length === 0) return {};
  const fields = search.split("&");
  const result: { [key: string]: string } = {};
  for (const field of fields) {
    const [key, val] = field.split("=");
    result[key] = val;
  }
  return result;
};

/**
 * Формат шифрования и дешифрования
 */
export const LertamRCFormat = {
  stringify: (cipherParams?: CryptoJS.lib.CipherParams): string => {
    if (cipherParams) {
      const j = [cipherParams.ciphertext.toString(CryptoJS.enc.Base64)];
      let iv = "";
      if (cipherParams.iv) {
        iv = cipherParams.iv.toString();
      }
      j.push(iv);
      let salt = "";
      if (cipherParams.salt) {
        salt = cipherParams.salt.toString();
      }
      j.push(salt);
      return j.join("-");
    }
    return "";
  },
  parse: (jsonStr: string): CryptoJS.lib.CipherParams => {
    const j = jsonStr.split("-");
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j[0]),
    });
    if (j[1] !== null) {
      cipherParams.iv = CryptoJS.enc.Hex.parse(j[1]);
    }
    if (j[2] !== null) {
      cipherParams.salt = CryptoJS.enc.Hex.parse(j[2]);
    }
    return cipherParams;
  },
};
